import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import CoachLayout from '../components/coach/CoachLayout';
import CoachSessions from '../components/coach/CoachSessions';
import CoursesManagement from '../components/admin/CoursesManagement';
import InteractiveLearningManagement from '../components/admin/InteractiveLearningManagement';
import ClassroomEnhanced from '../components/classroom/ClassroomEnhanced';
import './CoachDashboard.css';

const CoachDashboard = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.type !== 'coach') {
      navigate('/');
    }
  }, [user, navigate]);

  if (!user || user.type !== 'coach') {
    return null;
  }

  return (
    <CoachLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/coach/sessions" replace />} />
        <Route path="/sessions" element={<CoachSessions />} />
        <Route path="/courses" element={<CoursesManagement />} />
        <Route path="/content-studio" element={<InteractiveLearningManagement />} />
        <Route path="/classroom/:sessionId" element={<ClassroomEnhanced />} />
      </Routes>
    </CoachLayout>
  );
};

export default CoachDashboard;

